import { useEffect } from "react";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { ToggleButton, DecimalInput } from "components";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveRewardsTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const start = useInput("10");
  const end = useInput("");
  const type = useInput("X");
  const reward = useInput("Bonus Card Points");
  const isPurchase = useInput(true);
  const pStart = useInput("");
  const pEnd = useInput("");
  const pType = useInput("");
  const suffix = useInput("");
  const typeData = [
    { label: "%", value: "%" },
    { label: "$", value: "$" },
    { label: "X", value: "X" },
    { label: "Rewards", value: "Rewards" },
  ];
  const typeData2 = [
    { label: "$", value: "$" },
    { label: "Unit", value: "Unit" },
  ];
  const rewardData = [
    { label: "Bonus Card Points", value: "Bonus Card Points" },
    { label: "Box Tops Rewards", value: "Box Tops Rewards" },
    { label: "Credit Card Points", value: "Credit Card Points" },
    { label: "Gas Bonus Points", value: "Gas Bonus Points" },
    { label: "Labels for Learning", value: "Labels for Learning" },
    { label: "Labels for Education", value: "Labels for Education" },
    { label: "Rewards", value: "Rewards" },
    { label: "“R” Us", value: "“R” Us" },
    { label: "+ Up Rewards", value: "+ Up Rewards" },
    { label: "Balance Rewards", value: "Balance Rewards" },
    { label: "Cartwheel Points", value: "Cartwheel Points" },
    { label: "Extra Bucks", value: "Extra Bucks" },
    { label: "Familiplus", value: "Familiplus" },
    { label: "JcPenney Rewards", value: "JcPenney Rewards" },
    { label: "mPerks Rewards", value: "mPerks Rewards" },
    { label: "My Best Buy Points", value: "My Best Buy Points" },
    { label: "Office Depot Rewards", value: "Office Depot Rewards" },
    { label: "Office Max Rewards", value: "Office Max Rewards" },
    { label: "Plenti", value: "Plenti" },
    { label: "REDperks", value: "REDperks" },
    { label: "Register Rewards", value: "Register Rewards" },
    { label: "Sears Club Points", value: "Sears Club Points" },
    { label: "Shop Your Way Rewards", value: "Shop Your Way Rewards" },
    { label: "Staples Rewards", value: "Staples Rewards" },
    { label: "Wellness+ BonusCash", value: "Wellness+ BonusCash" },
    { label: "Yes Rewards", value: "Yes Rewards" },
    { label: "Yes2U", value: "Yes2U" },
    { label: "w/Ibotta App", value: "w/Ibotta App" },
    { label: "w/Fetch App", value: "w/Fetch App" },
    { label: "w/BUREA App", value: "w/BUREA App" },
    { label: "w/Checkout 51 App", value: "w/Checkout 51 App" },
    { label: "w/Brand Rewards", value: "w/Brand Rewards" },
  ];

  const formatFirstLine = (s, e, t) => {
    if (t === "$") {
      if (s && e) {
        return ` $${formatDollarValue(s)}-$${formatDollarValue(e)}`;
      } else if (s) {
        return ` $${formatDollarValue(s)}`;
      }
    } else if (t === "Rewards") {
      if (s && e) {
        return ` ${s}-${e}`;
      } else if (s) {
        return ` ${s}`;
      }
    } else {
      if (s && e) {
        return ` ${s}-${e}${t}`;
      } else if (s) {
        return ` ${s}${t}`;
      }
    }
    return "";
  };

  const formatPurchase = (isP, ps, pe, pt) => {
    if (isP) {
      let result = "w/purchase";
      if (ps && pe) {
        if (pt === "$") {
          result += `/$${formatDollarValue(ps)}-$${formatDollarValue(pe)}`;
        } else {
          result += `/${ps}-${pe}`;
        }
      } else if (ps) {
        if (pt === "$") {
          result += `/$${formatDollarValue(ps)}`;
        } else {
          result += `/${ps}`;
        }
      }
      return ` ${result}`;
    }
    return "";
  };

  const handleUpdateValue = (isU, s, e, t, r, isP, ps, pe, pt, suf) => {
    onChange(
      `Earn${isU ? " Up To" : ""}${formatFirstLine(s, e, t)}${r ? ` ${r}` : ""
      }${formatPurchase(isP, ps, pe, pt)}${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    if (value.startsWith("Earn")) {
      let main = value.slice(4).trimStart();
      if (main.startsWith("Up To")) {
        main = main.slice(5).trimStart();
        isUpTo.setValue(true);
      } else {
        isUpTo.setValue(false);
      }
      const pIdx = main.indexOf("w/purchase");
      if (pIdx >= 0) {
        const first = main.slice(0, pIdx).trim();
        const vIdx = first.indexOf(" ");
        if (vIdx) {
          let v = first.slice(0, vIdx).trim();
          if (v.startsWith("$")) {
            type.setValue("$");
            v = v
              .split("")
              .filter((s) => s !== "$")
              .join("");
          } else if (v.endsWith("%")) {
            type.setValue("%");
            v = v.slice(0, -1);
          } else if (v.endsWith("X")) {
            type.setValue("X");
            v = v.slice(0, -1);
          } else if (v.endsWith("Rewards")) {
            type.setValue("Rewards");
            v = v.slice(0, -7);
          }
          const endIdx = v.indexOf("-");
          if (endIdx > 0) {
            start.setValue(v.slice(0, endIdx).trim());
            end.setValue(v.slice(endIdx + 1).trim());
          } else {
            start.setValue(v.trim());
            end.setValue("");
          }
          reward.setValue(first.slice(vIdx).trim());
        } else {
          let v = first;
          if (v.startsWith("$")) {
            type.setValue("$");
            v = v
              .split("")
              .filter((s) => s !== "$")
              .join("");
          } else if (v.endsWith("%")) {
            type.setValue("%");
            v = v.slice(0, -1);
          } else if (v.endsWith("X")) {
            type.setValue("X");
            v = v.slice(0, -1);
          } else if (v.endsWith("Rewards")) {
            type.setValue("Rewards");
            v = v.slice(0, -7);
          }
          reward.setValue("");
        }
        let second = main.slice(pIdx + 10).trimStart();
        if (second.startsWith("/")) {
          second = second.slice(1).trimStart();
        }
        const isDigit = /^[0-9,$]$/.test(second[0]);

        //Check if the first character after w/purchase is a digit or a dollar sign, if so, parse the purchase value and type, otherwise set the suffix to the remaining string
        if(isDigit) {
          const sufIdx = second.indexOf(" ");

          if (sufIdx >= 0) {
            let pv = second.slice(0, sufIdx);
            if (pv.startsWith("$")) {
              pv = pv
                .split("")
                .filter((s) => s !== "$")
                .join("");
              pType.setValue("$");
            } else {
              pType.setValue("Unit");
            }
            const endIdx = pv.indexOf("-");
            if (endIdx > 0) {
              pStart.setValue(pv.slice(0, endIdx).trim());
              pEnd.setValue(pv.slice(endIdx + 1).trim());
            } else {
              pStart.setValue(pv.trim());
              pEnd.setValue("");
            }
            suffix.setValue(second.slice(sufIdx).trimStart());
          } else {
            let pv = second;
            if (pv.startsWith("$")) {
              pv = pv
                .split("")
                .filter((s) => s !== "$")
                .join("");
              pType.setValue("$");
            } else {
              pType.setValue("Unit");
            }
            const endIdx = pv.indexOf("-");
            if (endIdx > 0) {
              pStart.setValue(pv.slice(0, endIdx).trim());
              pEnd.setValue(pv.slice(endIdx + 1).trim());
            } else {
              pStart.setValue(pv.trim());
              pEnd.setValue("");
            }
            suffix.setValue("");
          }
        } else {
          suffix.setValue(second);
        }
      } else {
        const firstIdx = main.indexOf(" ");
        let first = "";
        if (firstIdx > 0) {
          first = main.slice(0, firstIdx).trim();
          let rest = main.slice(firstIdx);
          rest = rest.trimStart();
          rewardData.forEach((item) => {
            if (rest.startsWith(item.value)) {
              rest = rest.slice(item.value.length + 1);
              reward.setValue(item.value);
            }
          });
          suffix.setValue(rest);
        } else {
          first = main;
        }
        let v = first;
        if (
          v.startsWith("$") ||
          v.endsWith("%") ||
          v.endsWith("X") ||
          v.endsWith("Rewards")
        ) {
          if (v.startsWith("$")) {
            type.setValue("$");
            v = v
              .split("")
              .filter((s) => s !== "$")
              .join("");
          } else if (v.endsWith("%")) {
            type.setValue("%");
            v = v.slice(0, -1);
          } else if (v.endsWith("X")) {
            type.setValue("X");
            v = v.slice(0, -1);
          } else if (v.endsWith("Rewards")) {
            type.setValue("Rewards");
            v = v.slice(0, -7);
          }
          const endIdx = v.indexOf("-");
          if (endIdx > 0) {
            start.setValue(v.slice(0, endIdx).trim());
            end.setValue(v.slice(endIdx + 1).trim());
          } else {
            start.setValue(v.trim());
            end.setValue("");
          }
        }
      }
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3" style={{ width: '20%' }}>Earn</div>

        <ToggleButton label="Up To" className="mt-3 mx-2" value={isUpTo.value} style={{ width: '35%' }}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, start.value, end.value, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
          }}
        />

        {type.value === "$" ? (
          <DecimalInput labeled label="Start" placeholder="Start" style={{ width: '96%' }}
            value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(isUpTo.value, e, end.value, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Start" placeholder="Start" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(isUpTo.value, e, end.value, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
            }}
          />
        )}

        {type.value === "$" ? (
          <DecimalInput labeled label="End" placeholder="End" style={{ width: '96%' }}
            value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, e, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="End" placeholder="End" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, e, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '94%' }}
          options={typeData} value={type.value}
          onChange={(e) => {
            type.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, e, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <LabelledSelect label="Rewards" options={rewardData} value={reward.value}
          onChange={(e) => {
            reward.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, e, isPurchase.value, pStart.value, pEnd.value, pType.value, suffix.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton label="w/purchase" className="mt-3 mr-2" value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, e, pStart.value, pEnd.value, pType.value, suffix.value);
          }}
        />

        {pType.value === "$" ? (
          <DecimalInput labeled label="Start" placeholder="Start" style={{ width: '94%' }}
            value={pStart.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pStart.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, isPurchase.value, e, pEnd.value, pType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Start" placeholder="Start" style={{ width: '94%' }}
            allowclear="true" inputType="float" value={pStart.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pStart.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, isPurchase.value, e, pEnd.value, pType.value, suffix.value);
            }}
          />
        )}

        {pType.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '94%' }}
            value={pEnd.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pEnd.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, isPurchase.value, pStart.value, e, pType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" style={{ width: '94%' }}
            allowclear="true" inputType="float" value={pEnd.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pEnd.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, isPurchase.value, pStart.value, e, pType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" options={typeData2}
          value={pType.value || "Unit"} disabled={!isPurchase.value}
          onChange={(e) => {
            pType.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, e, suffix.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <LabelledInput label="Suffix" placeholder="Suffix"
          allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, reward.value, isPurchase.value, pStart.value, pEnd.value, pType.value, e);
          }}
        />
      </div>
    </>
  );
};